module.exports = "https://static.wmbcdn.com/uniweb/images/e04da5eec2436f2bf9edf97be382a991.svg";